<template>
  <div class="certificateTag">
    <div class="form-item">
      <label class="label"><i class="required">*</i>服务类型认证：</label>
      <div class="input-box">
        <div class="tag-item" v-for="(item,index) in stagesAuth" :key="item.ServiceStageId+''+index">
          {{item.DomainName}}-
          {{item.ServiceStageName}}
          <i class="el-icon el-icon-close" @click="removeStage(index)"></i>
        </div>
        <div class="btn-add" @click="showStage=true">
          <i class="el-icon el-icon-plus"></i>
          添加
        </div>
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>产品品牌认证：</label>
    </div>
    <div class="form-item" v-for="(domain,index) in domainList" :key="domain.DomainId">
      <label class="label">{{domain.DomainName}}</label>
      <div class="input-box">
        <template v-if="brandAuth[index]">
          <div class="tag-item" v-for="(item,i) in brandAuth[index]" :key="i">
            {{item.auth}}
            <i class="el-icon el-icon-close" @click="removeBrand(index,i)"></i>
          </div>
        </template>
        <div class="btn-add" @click="chooseDomain(index)">
          <i class="el-icon el-icon-plus"></i>
          添加
        </div>
      </div>
    </div>
    <div class="form-item">
      <span class="label"></span>
      <div class="input-box">
        <button class="btn-default" @click="prevStep">上一步</button>
        <button class="btn-primary" @click="save">下一步</button>
      </div>
    </div>
    <my-dialog class="stages-dialog" :show="showStage" titleCenter title="服务类型-认证" @close="showStage=false;showStageStep=1">
      <div class="domain-wrapper" v-if="showStageStep==1">
        <label class="domain-item" v-for="item in domainList" :key="'DomainId'+item.DomainId">
          <input class="radio" type="radio" name="domain" v-model="domainChecked" :value="item" />
          <span class="radio-val">{{item.DomainName}}</span>
        </label>
        <div class="btn-primary" @click="confirmDomain">确认</div>
      </div>
      <div class="check-wrapper" v-if="showStageStep!=1">
        <i class="icon-back" @click="showStageStep=1"></i>
        <ul class="check-list">
          <li v-for="item in serviceStagesList" :key="item.ServiceStageId">
            <label class="check-item" >
              <input class="checkbox" type="checkbox" name="stage" v-model="stagesChecked" :value="item" />
              <span class="text">{{item.ServiceStageName}}</span>
            </label>
          </li>
        </ul>
        <div class="btn-primary" @click="confirmStages">确认</div>
      </div>
    </my-dialog>
    <my-dialog class="brand-dialog" :show="showBrand" titleCenter title="工程师产品 - 品牌认证" @close="showBrand=false;showBrandStep=1;">
      <div class="check-wrapper" v-if="showBrandStep==1">
        <ul class="check-list">
          <li v-for="item in productList" :key="item.Id">
            <label class="check-item" >
              <input class="checkbox" type="radio" name="product" v-model="productChecked" :value="item" />
              <span class="text">{{item.ProductCategoryName}}</span>
            </label>
          </li>
        </ul>
        <div class="btn-primary" @click="confirmProduct">确认</div>
      </div>
      <div class="check-wrapper" v-if="showBrandStep!=1">
        <i class="icon-back" @click="showBrandStep=1"></i>
        <div class="search-wrapper">
          <div class="search-box">
            <input type="text" v-model="brandName" autocomplete="false" placeholder="输入您想要搜索的品牌" @keydown.enter="searchBrand">
            <i class="icon-search">
              <svg class="icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1312"><path d="M954.572 922.815l-167.229-180.474c71.167-76.249 114.775-178.533 114.775-290.814 0-235.209-191.361-426.563-426.563-426.563-235.209 0-426.563 191.355-426.563 426.563s191.355 426.563 426.563 426.563c93.821 0 180.667-30.449 251.172-81.984l168.429 181.771c7.977 8.617 18.829 12.975 29.721 12.975 9.85 0 19.725-3.573 27.519-10.791 16.402-15.21 17.391-40.836 2.175-57.245zM130.004 451.526c0-190.537 155.015-345.551 345.551-345.551 190.543 0 345.551 155.015 345.551 345.551s-155.007 345.552-345.551 345.552c-190.537 0-345.551-155.015-345.551-345.552z" p-id="1313"></path></svg>
            </i>
          </div>
          <button class="btn-text" @click="searchBrand">搜索</button>
          <button class="btn-check-all" v-if="!isCheckAll" @click="checkAll">全选</button>
          <button class="btn-check-all" v-if="isCheckAll" @click="checkAllFalse">取消全选</button>
        </div>
        <ul class="letter-list">
          <li v-for="(item,index) in letters" :class="{on:letterKey==item}" :key="index" @click="filterBrand(item)">{{item?item:'全部'}}</li>
        </ul>
        <ul class="check-list">
          <li v-for="item in filterBrandList" :key="item.BrandId">
            <label class="check-item">
              <input class="checkbox" ref="checkbox" type="checkbox" name="brand" v-model="brandChecked" :value="item" />
              <span class="text">{{item.BrandName}}</span>
            </label>
          </li>
        </ul>
        <div class="btn-primary" @click="confirmBrand">确认</div>
      </div>
    </my-dialog>
  </div>
</template>
<script>
import Dialog from "@/components/gkDialog.vue";
import { 
  AddErrorLog,
  ProductDomains,
  ServiceStagesByDomain,
  ProductBrands,
  GetServiceSiteAuthInfo,
} from '@/scripts/api.js'
import {mapState} from 'vuex'
import validate from '@/scripts/validate.js'
import Bus from '@/scripts/bus.js'
import _ from 'lodash'
export default {
  components: {
    "my-dialog": Dialog,
  },
  data(){
    return{
      serviceAuthData:null,
      showStage:false,
      showStageStep:1,
      domainList:[],
      domainChecked:'',
      serviceStagesList:[],
      stagesChecked:[],
      stagesAuth:[],
      showBrand:false,
      showBrandStep:1,
      productList:[],
      domainIndex:'',
      productChecked:'',
      brandList:[],
      filterBrandList:[],
      brandChecked:[],
      brandAuth:[],
      brandName:'',
      letterKey:'',
      isCheckAll:false,
      letters:['','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
    }
  },
  props:{
    isEdit:{
      type:Boolean,
      default:false,
    }
  },
  computed: {
    ...mapState({
      serviceInfo:state=>state.serviceInfo,
    })
  },
  watch: {
    domainChecked:{
      handler(value,old){
        if(value){
          this.stagesChecked=[];
        }
      },
      deep:true,
    },
    serviceInfo(value){
      if(value){
        let arr=[];
        for (let i = 0; i < value.ServiceStageTagList.length; i++) {
          let obj = {
            ...value.ServiceStageTagList[i],
            DomainId:value.ServiceStageTagList[i].DomainID,
          };
          arr.push(obj);
        }
        this.stagesAuth=arr;
        this.loadDomain();
      }
    }
  },
  mounted() {
    this.loadDomain();
    let that=this;
    Bus.$on('toServiceAuth2',function (params) {
      that.serviceAuthData=params;
      console.log(that.serviceAuthData);
    });
  },
  methods: {
    //上一步
    prevStep(){
      this.$emit('stepChange',2);
    },
    //领域
    loadDomain(){
      ProductDomains({
        platform:'pcweb',
      }).then(r=>{
        if(r.Result==1){
          this.domainList=r.Data;
          let list=this.serviceInfo && this.serviceInfo.ProductBrandTagList?this.serviceInfo.ProductBrandTagList: [];
          for (let i = 0; i < this.domainList.length; i++) {
            this.brandAuth[i]=[];
            for (let j = 0; j < list.length; j++) {
              if(this.domainList[i].DomainId==list[j].DomainID){
                //根据产品id分组，返回一个对象
                var product=_.groupBy(list[j].ProductTagList,'ProductId');
                for (const k in product) {
                  //对象的属性是不同产品的ID，
                  let obj={
                    ...this.domainList[i],
                    Id:Number(k),
                    brands:product[k],
                  }
                  var brandNameArr=_.map(product[k],item=>{
                    return item.BrandName
                  });
                  if(brandNameArr.length){
                    obj['auth']=product[k][0].ProductName+'-'+brandNameArr.join('/');
                    obj['ProductCategoryName']=product[k][0].ProductName;
                  }
                  this.brandAuth[i].push(obj);
                }
              }
            }
          }
        }
      })
    },
    //选中领域
    confirmDomain(){
      if(this.domainChecked==''){
        return;
      }
      ServiceStagesByDomain({
        ProductDomainId:this.domainChecked.DomainId,
        platform:'pcweb',
      }).then(r=>{
        if(r.Result==1){
          this.serviceStagesList=r.Data.Lines;
          this.showStageStep=2;
        }
      });
    },
    //添加服务类型
    confirmStages(){
      if(this.stagesChecked.length==0){
        return;
      }
      // let str='';
      var arr=[];
      
      for (let i = 0; i < this.stagesChecked.length; i++) {
        let obj={
          ...this.domainChecked,
          ...this.stagesChecked[i],
        }
        for (let j = 0; j < this.stagesAuth.length; j++) {
          if(this.stagesAuth[j].DomainId==this.domainChecked.DomainId && this.stagesAuth[j].ServiceStageName==this.stagesChecked[i].ServiceStageName){
            this.stagesAuth.splice(j,1);
          }
        }
        this.stagesAuth.push(obj);
      }
      this.showStage=false;
      this.showStageStep=1;
    },
    //删除类型
    removeStage(index){
      this.stagesAuth.splice(index,1);
    },
    //选择领域添加品牌
    chooseDomain(index){
      this.domainIndex=index;
      this.productChecked='';
      this.brandChecked=[];
      this.loadProductList(this.domainList[index].DomainId);
    },
    //加载产品和品牌
    loadProductList(domainId,productId){
      let params=null;
      if(domainId){
        params={
          platform:'pcweb',
          ProductCategoryLv1:[domainId],
        }
      }
      if(productId){
        params={
          platform:'pcweb',
          ProductId:productId,
        }
        this.brandChecked=[];
      }
      ProductBrands(params).then(r=>{
        if(r.Result==1){
          let list=r.Data || [];
          if(domainId){
            this.productList=list;
            if(list.length){
              this.showBrand=true;
            }else{
              this.$toast('该领域下没有相关产品');
            }
            
          }
          if(productId){
            this.brandList=list.length?list[0].Brands:[];
            this.filterBrandList=this.brandList;
            if(list.length){
              this.showBrandStep=2;
            }else{
              this.$toast('该产品没有相关品牌');
            }
          }
        }
      })
    },
    //搜索品牌
    searchBrand(){
      this.filterBrandList=this.brandList.filter(item=>{
        return item.BrandName.indexOf(this.brandName)!=-1
      })
    },
    //筛选品牌
    filterBrand(key){
      this.letterKey=key;
      if(!key){
        this.filterBrandList=this.brandList;
        return;
      }
      this.filterBrandList=this.brandList.filter(item=>{
        return item.BrandNameFirstLetter==key;
      })
    },
    //全选
    checkAll(){
      for (let i = 0; i < this.$refs.checkbox.length; i++) {
        if(!this.$refs.checkbox[i].checked){
          this.$refs.checkbox[i].click();
        }
      }
      this.isCheckAll=true;
    },
    //取消全选
    checkAllFalse(){
      for (let i = 0; i < this.$refs.checkbox.length; i++) {
        if(this.$refs.checkbox[i].checked){
          this.$refs.checkbox[i].click();
        }
      }
      this.isCheckAll=false;
    },
    //确认产品
    confirmProduct(){
      if(!this.productChecked){
        this.$toast('请选择产品');
        return;
      }
      this.isCheckAll=false;
      this.loadProductList(null,this.productChecked.Id);
    },
    //确认品牌
    confirmBrand(){
      if(this.brandChecked.length==0){
        this.$toast('请选择品牌');
        return;
      }
      let obj={
        ...this.domainList[this.domainIndex],
        ...this.productChecked,
        brands:this.brandChecked,
      }
      let name='';
      for (let i = 0; i < this.brandChecked.length; i++) {
        if(i==0){
          name+= this.brandChecked[i].BrandName;
        }else{
          name+= '/'+this.brandChecked[i].BrandName;
        }
      }
      for (let i = 0; i < this.brandAuth[this.domainIndex].length; i++) {
        if(this.brandAuth[this.domainIndex][i].DomainId==obj.DomainId && this.brandAuth[this.domainIndex][i].Id==obj.Id){
          this.brandAuth[this.domainIndex].splice(i,1);
        }
      }
      obj.auth=this.productChecked.ProductCategoryName+'-'+name;
      this.brandAuth[this.domainIndex].push(obj);
      console.log(this.brandAuth);
      this.showBrand=false;
      this.showBrandStep=1;
    },
    //删除品牌认证
    removeBrand(index,i){
      this.brandAuth[index].splice(i,1);
      this.$forceUpdate();
    },
    //下一步
    save(){
      console.log(this.stagesAuth);
      let stages=[];
      for (let i = 0; i < this.stagesAuth.length; i++) {
        let obj = {
          domainID:this.stagesAuth[i].DomainId,
          serviceStageId :this.stagesAuth[i].ServiceStageId,
        };
        stages.push(obj);
      }
      if(stages.length==0){
        this.$toast('请添加服务类型认证');
        return;
      }
      let PBAuth=[];
      for (let i = 0; i < this.brandAuth.length; i++) {
        for (let j = 0; j < this.brandAuth[i].length; j++) {
          for (let k = 0; k < this.brandAuth[i][j].brands.length; k++) {
            let obj={
              domainID:this.brandAuth[i][j].DomainId,
              domainName:this.brandAuth[i][j].DomainName,
              productId:this.brandAuth[i][j].Id,
              productName:this.brandAuth[i][j].ProductCategoryName,
              brandId:this.brandAuth[i][j].brands[k].BrandId,
              brandName:this.brandAuth[i][j].brands[k].BrandName,
            }
            PBAuth.push(obj);
          }
        }
      }
      if(PBAuth.length==0){
        this.$toast('请添加产品品牌认证');
        return;
      }
      this.$emit('stepChange',4);
      console.log(this.serviceAuthData);
      let data={
        serviceStageTagList:stages,
        productAndBrandTagList:PBAuth,
        ...this.serviceAuthData
      }
      Bus.$emit('toServiceAuth3',data);
    },
  },
}
</script>
<style lang="scss">
.certificateTag{
  .label{
    text-align: right;
  }
  .tag-item{
    width: 500px;
    min-height: 38px;
    border: 1px solid #e7e7e7;
    padding: 8px 40px;
    background-color: #fff;
    text-align: center;
    font-size: 14px;
    color: #333;
    line-height: 22px;
    margin-bottom: 10px;
    word-break: break-all;
    position: relative;
    &:hover{
      border-color: #f75959;
      .el-icon-close{
        color: #f75959;
      }
    }
  }
  .el-icon-close{
    font-size: 16px;
    font-weight: bold;
    color: #e7e7e7;
    position: absolute;
    right:0;
    top: 0;
    width: 40px;
    text-align: center;
    cursor: pointer;
    line-height: 38px;
  }
  .btn-add{
    width: 100%;
    height: 38px;
    border: 1px solid #e7e7e7;
    padding: 8px 40px;
    background-color: #fff;
    text-align: center;
    font-size: 14px;
    color: #f75959;
    line-height: 22px;
    cursor: pointer;
    .el-icon-plus{
      margin-right:4px;
      font-weight: bold;
    }
    &:hover{
      border-color: #f75959;
    }
  }
  
  .check-wrapper{
    .btn-primary{
      display: block;
      height: 30px;
      line-height: 30px;
      margin: 20px auto 0;
    }
    .check-list{
      overflow: hidden;
      width: 680px;
      height: 320px;
      overflow-y: auto;
      >li{
        float: left;
        margin-right: 10px;
        margin-bottom: 15px;
        &:nth-child(4n){
          margin-right: 0;
        }
      }
    }
    
  }
  .check-item{
    position: relative;
    display: block;
    .checkbox{
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
    .text{
      display: block;
      padding: 0 10px;
      width: 157px;
      overflow: hidden;
      text-align: center;
      height: 40px;
      border: 1px solid #f9f9f9;
      font-size: 14px;
      color: #333;
      line-height: 38px;
      background-color: #f9f9f9;
      border-radius: 2px;
    }
    .checkbox:checked+.text{
      border-color: #f75959;
    }
  }
  .icon-back{
    position: absolute;
    left: 0px;
    top: 0;
    z-index: 2;
    width: 40px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    cursor: pointer;
    &:before{
      content:'';
      display: inline-block;
      width: 10px;
      height: 10px;
      border-left: 1px solid #fff;
      border-bottom: 1px solid #fff;
      transform: rotate(45deg);
    }
  }
  .search-wrapper{
    overflow: hidden;
    margin-bottom: 6px;
    .btn-check-all{
      float: right;
      font-size: 14px;
      color: #666;
      line-height: 30px;
      background-color: transparent;
      margin-left: 10px;
      cursor: pointer;
      }
  }
  .search-box{
    float: left;
    position: relative;
    input{
      width: 280px;
      border: 1px solid #e5e5e5;
      background: #fff;
      padding-left: 35px;
      border-radius: 30px;
      line-height: 30px;
      height: 30px;
      font-size: 14px;
      font-family: "DIN-Regular";
      color: #666;
    }
    .icon-search{
      position: absolute;
      left: 10px;
      top: 4px;
      line-height: 1;
      font-size:18px;
      color: #f75959;
    }
  }
  .btn-text{
    float: left;
    font-size: 14px;
    color: #f75959;
    line-height: 30px;
    background-color: transparent;
    margin-left: 10px;
    cursor: pointer;
  }
  .letter-list{
    overflow: hidden;
    width: 100%;
    margin-bottom: 6px;
    >li{
      float: left;
      margin-right: 6px;
      padding-left: 4px;
      padding-right: 4px;
      line-height: 24px;
      cursor: pointer;
      font-size: 14px;
      color: #333;
      &.on{
        color: #f75959;
      }
      &:hover{
        color: #f75959;
      }
    }
  }
}
.stages-dialog{
  .domain-wrapper{
    padding: 30px 0 0;
    text-align: center;
    .btn-primary{
      height: 30px;
      line-height: 30px;
      margin-top: 20px;
    }
  }
  .domain-item{
    position: relative;
    display: block;
    width: 400px;
    margin: 0 auto 20px;
    .radio{
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
    .radio-val{
      display: block;
      width: 400px;
      height: 40px;
      border: 1px solid #f9f9f9;
      font-size: 14px;
      color: #333;
      line-height: 38px;
      background-color: #f9f9f9;
      border-radius: 2px;
    }
    .radio:checked+.radio-val{
      border-color: #f75959;
    }
  }
}
</style>